import { HBox } from '../../layout';
import React from 'react';

/**
 * Props for a {@link PatientDetailsHorizontalFlexElement} component.
 */
type PatientDetailsHorizontalFlexElementProps = {
  label: string;
  value: string;
};

/**
 * Simple component for elements that are meant to be displayed in the form of
 * "Label: Value" with specific flex values.
 *
 * @param props a {@link PatientDetailsHorizontalFlexElementProps} object
 * @return the created {@link React.JSX.Element}.
 * @constructor
 */
export function PatientDetailsHorizontalFlexElement({
  label,
  value
}: Readonly<PatientDetailsHorizontalFlexElementProps>): React.JSX.Element {
  return (
    <HBox className="ehs-patient-details-horizontal-flex-element">
      <span className="label">{label}</span>
      <span className="value">{value}</span>
    </HBox>
  );
}
